<template>
  <el-row class="mb-10 group-title-table">
    <el-col :span="12" class="table-quantity-data table-notice-data">{{ $t('quantity_item_is_showing_table_header', [recordStart, recordEnd, data.total]) }}</el-col>
    <el-col :span="12" class="text-right" v-if="hasCreate">
      <el-button type="success" class="btn-create" @click="$emit('handleRedirectCreate')" >{{ $t('btn_create') }}</el-button>
    </el-col>
  </el-row>
  <div class="group-input mt-0"></div>
  <div class="tbl-notice">
    <div v-for="item in data.records" :key="item.id" class="notice">
      <div class="header">
        <span>{{ formatDate(item.created_at) }}</span>
        <span class="ml-20">{{ item.category_name }}</span>
      </div>
      <el-row class="title">
        <el-col :span="18">
          <p class="title">{{ item.title }}</p>
        </el-col>
      </el-row>
      <div class="content">
        <el-row>
          <el-col :span="22" v-html="item.content" class="main"></el-col>
          <el-col :span="24" class="detail">
            <img class="btn-detail" src="/images/icon-redirect-right.svg" @click="showDetail(item.id)"/>
          </el-col>
        </el-row>
      </div>
      <hr/>
    </div>
  </div>
  <p class="table-quantity-data padding-top-list text-center">
    {{ $t('quantity_item_is_showing_table_footer', [data.total, recordStart, recordEnd]) }}
  </p>
  <el-pagination
    background
    layout="prev, pager, next"
    :total="data.total" :page-size="data.perPage"
    prev-text="＜ 前へ" next-text="次へ ＞"
    :currentPage="data.currentPage"
    @current-change="handleChangePage"
  />
</template>
<script>
  export default {
    props: {
      data: { type: Object, required: true, default: {} },
      loading: { type: Boolean, required: true, default: false },
      hasCreate: { type: Boolean, required: false, default: false },
    },

    emits: ['changePage', 'redirectDetail', 'handleRedirectCreate'],

    data() {
      return {
      }
    },

    methods: {
      handleChangePage(page) {
        this.$emit('changePage', page);
      },
      showDetail(id) {
        this.$emit('redirectDetail', id);
      },
      formatDate(dateTime) {
        return dateTime ? this.$dayjs(dateTime).format('YY.MM.DD') : '';
      }
    },

    computed: {
      recordStart() {
        return (this.data.total > 0) ? (this.data.currentPage - 1) * this.data.perPage + 1 : 0;
      },

      recordEnd() {
        const temp = this.data.currentPage * this.data.perPage;
        return (temp >= this.data.total) ? this.data.total : temp;
      },
    },

    created() {
    }
  }
</script>
<style lang="scss" scoped>
  .tbl-notice {
    margin-top: 20px;
    .header {
      font: normal normal normal 12px/26px Kozuka Gothic Pr6N;
      letter-spacing: 1.8px;
      color: #7B7B7B;
    }
    .title {
      height: 30px;
      align-content: center;
      p {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        color: #000000;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: bold;
        margin: 0;
      }
    }

    .content {
      font: normal normal normal 13px/30px Kozuka Gothic Pr6N;
      letter-spacing: 1.3px;
      color: #000000;
      .main {
        overflow: hidden;
        text-overflow: ellipsis;
        line-height: 25px;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .detail {
        text-align: right;
        position: absolute;
        bottom: 10px;
        width: 100%;
        line-height: 0px;
        .btn-detail {
          width: 29px;
          height: 29px;
          cursor: pointer;
        }
      }
    }
  }
  hr {
    opacity: 1;
  }
</style>
